import React, { useState } from 'react';
import { useAppDispatch } from '../../../../../app/redux/useAppSelector';
import EmojiPicker, {
  EmojiPickerContainer,
} from '../../../../../components/EmojiPicker';
import reactionIcon from '../../../../../icons/non-prefilled/16x16/reaction.svg';
import { EditorActions } from '../../../../editorSlice';
import type { Blot } from '../../../../types';
import usePickReaction from '../../usePickReaction';
import ToolbarButton from '../ToolbarButton';
import selectBlotAndWaitMagneticWallUpdate from './selectBlotAndWaitMagneticWallUpdate';

interface ToolbarReactionButtonProps {
  blot?: Blot;
  onPickerOpenChange?: (open: boolean) => void;
}

const ToolbarReactionButton = ({
  blot,
  onPickerOpenChange,
}: ToolbarReactionButtonProps) => {
  const dispatch = useAppDispatch();

  const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);

  const handlePick = usePickReaction();

  return (
    <ToolbarButton
      icon={reactionIcon}
      tooltip="Add reaction"
      popOverHideCaret
      renderPopOver={(onClose: () => void) => (
        <EmojiPickerContainer>
          <EmojiPicker
            onPick={(picked: string) => {
              handlePick(picked);
              onClose();
            }}
          />
        </EmojiPickerContainer>
      )}
      popOverOpen={isEmojiPickerOpen}
      onPopOverOpenChange={async (open: boolean) => {
        setIsEmojiPickerOpen(open);
        onPickerOpenChange?.(open);

        if (open && blot) {
          await selectBlotAndWaitMagneticWallUpdate(blot);
        }
        dispatch(EditorActions.setIsPickingReaction(open));
      }}
    />
  );
};

export default ToolbarReactionButton;
